import { FC, ReactNode } from 'react';
import './BoxShadowContainer.css';

type Props = {
  children: ReactNode;
  className?: string;
};

/** Card ground. Colours come from the token layer (BoxShadowContainer.css),
 *  which already switches with the colour mode — no mode class needed. */
const BoxShadowContainer: FC<Props> = ({ children, className }) => {
  return (
    <div className={`box-shadow-container ${className}`}>
      {children}
    </div>
  );
};

export default BoxShadowContainer;
